import { type BaseStocktakeAccumulatedRepository } from "../../_Bases/BaseStocktakeAccumulatedRepository";
import { type LocalDatabaseStocktakeAccumulated } from "../../_Bases/BaseStocktakeAccumulatedRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBStocktakeAccumulatedRepository extends BaseIndexedDBRepository<
    LocalDatabaseStocktakeAccumulated
> implements BaseStocktakeAccumulatedRepository {
    public readonly source: InternalIndexedDBDatabase["stocktakeAccumulated"];
    protected readonly dataTypeName = "Stocktake Accumulated";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.stocktakeAccumulated;
    }

    public getByStocktake(stocktake: string): Promise<Array<LocalDatabaseStocktakeAccumulated>> {
        return this.source.where("stocktake_id").equals(stocktake).toArray();
    }
}
